import { SmartAgentMatcher } from '../core/smartAgentMatcher';
import { ProjectFeatures, AgentMetadata, ConsoleLogger } from '../core/types';
import { getResourceLoader } from '../core/resourceLoader.js';

/**
 * 匹配 Agents 工具
 */
export async function matchAgents(args: {
    projectFeatures: ProjectFeatures;
    limit?: number;
}): Promise<{
    content: Array<{ type: string; text: string }>;
}> {
    const logger = new ConsoleLogger();
    
    try {
        const matcher = new SmartAgentMatcher(logger);
        const resourceLoader = getResourceLoader(logger);

        logger.log('正在从包内加载 Agents...');

        // 从 npm 包内部加载所有 Agents
        const availableAgents = resourceLoader.loadAllAgents();

        // 匹配 Agents
        const matchedAgents = matcher.matchAgents(args.projectFeatures, availableAgents);
        
        // 限制返回数量
        const limit = args.limit || 10;
        const topAgents = matchedAgents.slice(0, limit);

        return {
            content: [{
                type: 'text',
                text: JSON.stringify({
                    success: true,
                    totalAvailable: availableAgents.length,
                    matched: topAgents.length,
                    agents: topAgents.map(agent => ({
                        id: agent.id,
                        title: agent.title,
                        description: agent.description,
                        score: agent.score,
                        tags: agent.tags,
                        path: agent.path
                    })),
                    recommendations: topAgents.slice(0, 5).map(a => a.title)
                }, null, 2)
            }]
        };
    } catch (error) {
        logger.error(`匹配 Agents 失败: ${error}`);
        return {
            content: [{
                type: 'text',
                text: JSON.stringify({
                    error: error instanceof Error ? error.message : String(error)
                }, null, 2)
            }]
        };
    }
}
